import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import * as _ from 'lodash';
import { ODataModel } from '../../interfaces/odata-model.interface';
import { TableModel } from '../../models/complex/table.model';

@Component({
    selector: 'pace-core-sortable-list',
    templateUrl: './sortable-list.component.html',
    styleUrls: ['./sortable-list.component.scss'],
    standalone: false,
})
export class SortableListComponent implements OnInit, OnChanges {
    @Input()
    public model: TableModel<ODataModel>;

    @Output()
    public rowClicked = new EventEmitter<ODataModel>();

    public orderByField: string;
    public reverseSort: boolean;

    public faSortDown = faSortDown;
    public faSortUp = faSortUp;

    public ngOnInit(): void {
        this.orderByField = this.model.options.sortColumn;
        this.reverseSort = this.model.options.reverseSort;
        this.model.selectByIndex(this.model.options.initialSelectRow);
    }

    public ngOnChanges(changesObj: SimpleChanges): void {
        if (changesObj.model) {
            this.model = <TableModel<ODataModel>>changesObj.model.currentValue;
            this.orderByField = this.model.options.sortColumn;
            this.reverseSort = this.model.options.reverseSort;
            this.model.selectByIndex(this.model.options.initialSelectRow);
        }
    }

    public doSort(field: string): void {
        this.orderByField = field;
        this.reverseSort = !this.reverseSort;
    }

    public rowClick(row: ODataModel): void {
        this.model.selectedRow = row;
        this.rowClicked.emit(this.model.selectedRow);
    }

    public get(row: ODataModel, field: string): unknown {
        return _.get(row, field);
    }
}
